/**
 * Persistent "Powered by" attribution in the bottom-right corner.
 * Fixed position so it's visible on any page without competing with content flow.
 * Hidden while the exam is in fullscreen? — actually shows there too, sits above the
 * exam content because z-40, non-interactive except for the link.
 */
export function PoweredBy() {
  return (
    <div
      className="pointer-events-none fixed bottom-2 right-3 z-40 select-none text-[11px] text-brand-ink/50"
      aria-hidden="false">
      <a
        href="https://redanglo.com"
        target="_blank"
        rel="noopener noreferrer"
        className="pointer-events-auto rounded-full bg-white/70 px-2 py-1 backdrop-blur hover:text-brand"
      >
        Powered by <span className="font-semibold">redanglo.com</span>
      </a>
    </div>
  );
}
